export default {
  data() {
    return {
      // 0か1かでソートが昇順か降順かを見る
      mixinCurrentSort: 0,
      // 今どの項目に対してソートがかかっているかを保存
      mixinChoiceSort: '',
    }
  },
  methods: {
    // 数字等の低い順のソート
    mixinNumberAscending(list, key) {
      list.sort((a, b) => {
        const numA = a[`${key}`] ? a[`${key}`] : null
        const numB = b[`${key}`] ? b[`${key}`] : null
        return numA - numB
      })
      return list
    },
    // 数字等の高い順のソート
    mixinNumberDescending(list, key) {
      list.sort((a, b) => {
        const numA = a[`${key}`] ? a[`${key}`] : null
        const numB = b[`${key}`] ? b[`${key}`] : null
        return numB - numA
      })
      return list
    },
    // 文字の低い順のソート
    mixinWordAscending(list, key) {
      list.sort((a, b) => {
        const wordA = a[`${key}`]
          ? this.mixinToHalfWidth(a[`${key}`].toUpperCase())
          : '' // 大文字と小文字を無視する
        const wordB = b[`${key}`]
          ? this.mixinToHalfWidth(b[`${key}`].toUpperCase())
          : '' // 大文字と小文字を無視する
        if (wordA < wordB) return -1
        if (wordA > wordB) return 1
        return 0
      })
      return list
    },
    // 文字の高い順のソート
    mixinWordDescending(list, key) {
      list.sort((a, b) => {
        const wordA = a[`${key}`]
          ? this.mixinToHalfWidth(a[`${key}`].toUpperCase())
          : '' // 大文字と小文字を無視する
        const wordB = b[`${key}`]
          ? this.mixinToHalfWidth(b[`${key}`].toUpperCase())
          : '' // 大文字と小文字を無視する
        if (wordA > wordB) return -1
        if (wordA < wordB) return 1
        return 0
      })
      return list
    },
    // Spacesの文字の低い順
    mixinSpacesAscending(list, key) {
      list.sort((a, b) => {
        const spaceA =
          a.spaces &&
          a.spaces[`${key}`] &&
          this.mixinSpacesDisplay(a.spaces[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinSpacesDisplay(a.spaces[`${key}`]).toUpperCase()
            )
            : ''
        const spaceB =
          b.spaces &&
          b.spaces[`${key}`] &&
          this.mixinSpacesDisplay(b.spaces[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinSpacesDisplay(b.spaces[`${key}`]).toUpperCase()
            )
            : ''
        if (spaceA < spaceB) return -1
        if (spaceA > spaceB) return 1
        return 0
      })
      return list
    },
    // Spacesの文字の高い順
    mixinSpacesDescending(list, key) {
      list.sort((a, b) => {
        const spaceA =
          a.spaces &&
          a.spaces[`${key}`] &&
          this.mixinSpacesDisplay(a.spaces[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinSpacesDisplay(a.spaces[`${key}`]).toUpperCase()
            )
            : ''
        const spaceB =
          b.spaces &&
          b.spaces[`${key}`] &&
          this.mixinSpacesDisplay(b.spaces[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinSpacesDisplay(b.spaces[`${key}`]).toUpperCase()
            )
            : ''
        if (spaceA > spaceB) return -1
        if (spaceA < spaceB) return 1
        return 0
      })
      return list
    },
    // inventoryKindsの文字の低い順
    mixinKindsAscending(list, key) {
      list.sort((a, b) => {
        const kindA =
          a[`${key}`] && this.mixinInventoryKindDisplay(a[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinInventoryKindDisplay(a[`${key}`]).toUpperCase()
            )
            : ''
        const kindB =
          b[`${key}`] && this.mixinInventoryKindDisplay(b[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinInventoryKindDisplay(b[`${key}`]).toUpperCase()
            )
            : ''
        if (kindA < kindB) return -1
        if (kindA > kindB) return 1
        return 0
      })
      return list
    },
    // inventoryKindsの文字の高い順
    mixinKindsDescending(list, key) {
      list.sort((a, b) => {
        const kindA =
          a[`${key}`] && this.mixinInventoryKindDisplay(a[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinInventoryKindDisplay(a[`${key}`]).toUpperCase()
            )
            : ''
        const kindB =
          b[`${key}`] && this.mixinInventoryKindDisplay(b[`${key}`])
            ? this.mixinToHalfWidth(
              this.mixinInventoryKindDisplay(b[`${key}`]).toUpperCase()
            )
            : ''
        if (kindA > kindB) return -1
        if (kindA < kindB) return 1
        return 0
      })
      return list
    },
    // 品番と品名の文字の低い順
    mixinProductsAscending(list, key) {
      list.sort((a, b) => {
        const productA =
          a.productId && this.mixinProductDisplay(a.productId, key)
            ? this.mixinToHalfWidth(
              this.mixinProductDisplay(a.productId, key).toUpperCase()
            )
            : ''
        const productB =
          b.productId && this.mixinProductDisplay(b.productId, key)
            ? this.mixinToHalfWidth(
              this.mixinProductDisplay(b.productId, key).toUpperCase()
            )
            : ''
        if (productA < productB) return -1
        if (productA > productB) return 1
        return 0
      })
      return list
    },
    // 品番と品名の文字の高い順
    mixinProductsDescending(list, key) {
      list.sort((a, b) => {
        const productA =
          a.productId && this.mixinProductDisplay(a.productId, key)
            ? this.mixinToHalfWidth(
              this.mixinProductDisplay(a.productId, key).toUpperCase()
            )
            : ''
        const productB =
          b.productId && this.mixinProductDisplay(b.productId, key)
            ? this.mixinToHalfWidth(
              this.mixinProductDisplay(b.productId, key).toUpperCase()
            )
            : ''
        if (productA > productB) return -1
        if (productA < productB) return 1
        return 0
      })
      return list
    },
    // 出庫計画作成の時のロット並べ替えのソート
    mixinCreateLeaveLotAscending(key, id) {
      // 出庫可能数が無いものを排除
      const canChoiceList = this[key].filter(item => {
        if (
          id === item.inventoryId &&
          item.remainDay >= 0 &&
          item.planQuantity > 0 &&
          item.state !== 'none' &&
          item.quantity > 0
        )
          return true
      })

      canChoiceList.sort((a, b) => {
        const planQuantityA = a.planQuantity ? 1 : 0
        const planQuantityB = b.planQuantity ? 1 : 0
        const diffQuantityA = a.quantity ? a.quantity - a.planQuantity : 0
        const diffQuantityB = b.quantity ? b.quantity - b.planQuantity : 0
        const limitDateA = a.limitDate
        const limitDateB = b.limitDate
        if (planQuantityA < planQuantityB) return -1
        if (planQuantityA > planQuantityB) return 1
        if (limitDateA < limitDateB) return -1
        if (limitDateA > limitDateB) return 1
        if (diffQuantityA < diffQuantityB) return -1
        if (diffQuantityA > diffQuantityB) return 1
        return 0
      })
      return canChoiceList
    },
    // ソートのアイコンの表示と非表示切り替え
    mixinVisibleSort(key) {
      let activeSortAsc = document.querySelector('.thead .asc')
      let activeSortDes = document.querySelector('.thead .des')
      if (activeSortAsc) activeSortAsc.classList.remove('asc')
      if (activeSortDes) activeSortDes.classList.remove('des')
      const keySort = document.getElementById(`${key}`)
      if (this.mixinCurrentSort === 0) {
        keySort.querySelector('.ascending').style.display = 'inline-block'
        keySort.querySelector('.descending').style.display = 'none'
        keySort.classList.add('asc')
      } else {
        keySort.querySelector('.ascending').style.display = 'none'
        keySort.querySelector('.descending').style.display = 'inline-block'
        keySort.classList.add('des')
      }
    },
    // ソートのタイプを分ける処理
    mixinSearchNumberSort(key) {
      if (this.mixinChoiceSort === key) {
        this.mixinCurrentSort = this.mixinCurrentSort === 0 ? 1 : 0
        if (this.mixinCurrentSort === 0) {
          this.list = this.mixinNumberAscending(this.list, key)
        } else {
          this.list = this.mixinNumberDescending(this.list, key)
        }
      } else {
        this.mixinChoiceSort = key
        this.mixinCurrentSort = 0
        this.list = this.mixinNumberAscending(this.list, key)
      }
      this.mixinVisibleSort(key)
      this.mixinCurrentPageClear()
    },
    // ソートのタイプを分ける処理
    mixinSearchWordSort(key) {
      if (this.mixinChoiceSort === key) {
        this.mixinCurrentSort = this.mixinCurrentSort === 0 ? 1 : 0
        if (this.mixinCurrentSort === 0) {
          this.list = this.mixinWordAscending(this.list, key)
        } else {
          this.list = this.mixinWordDescending(this.list, key)
        }
      } else {
        this.mixinChoiceSort = key
        this.mixinCurrentSort = 0
        this.list = this.mixinWordAscending(this.list, key)
      }
      this.mixinVisibleSort(key)
      this.mixinCurrentPageClear()
    },
    // 場所と棚番のソートのタイプを分ける処理
    mixinSearchSpacesSort(key) {
      if (this.mixinChoiceSort === key) {
        this.mixinCurrentSort = this.mixinCurrentSort === 0 ? 1 : 0
        if (this.mixinCurrentSort === 0) {
          this.list = this.mixinSpacesAscending(this.list, key)
        } else {
          this.list = this.mixinSpacesDescending(this.list, key)
        }
      } else {
        this.mixinChoiceSort = key
        this.mixinCurrentSort = 0
        this.list = this.mixinSpacesAscending(this.list, key)
      }
      this.mixinVisibleSort(key)
      this.mixinCurrentPageClear()
    },
    // 区分のソートのタイプを分ける処理
    mixinSearchKindsSort(key) {
      if (this.mixinChoiceSort === key) {
        this.mixinCurrentSort = this.mixinCurrentSort === 0 ? 1 : 0
        if (this.mixinCurrentSort === 0) {
          this.list = this.mixinKindsAscending(this.list, key)
        } else {
          this.list = this.mixinKindsDescending(this.list, key)
        }
      } else {
        this.mixinChoiceSort = key
        this.mixinCurrentSort = 0
        this.list = this.mixinKindsAscending(this.list, key)
      }
      this.mixinVisibleSort(key)
      this.mixinCurrentPageClear()
    },

    // 品番と品名のソートタイプを分ける処理
    mixinSearchProduct(key) {
      if (this.mixinChoiceSort === key) {
        this.mixinCurrentSort = this.mixinCurrentSort === 0 ? 1 : 0
        if (this.mixinCurrentSort === 0) {
          this.list = this.mixinProductsAscending(this.list, key)
        } else {
          this.list = this.mixinProductsDescending(this.list, key)
        }
      } else {
        this.mixinChoiceSort = key
        this.mixinCurrentSort = 0
        this.list = this.mixinProductsAscending(this.list, key)
      }
      this.mixinVisibleSort(key)
      this.mixinCurrentPageClear()
    },
    // sortのデータを統一（全角から半角に）
    mixinToHalfWidth(strVal) {
      if (strVal === null) {
        return strVal
      }
      // 半角変換
      let halfVal = strVal.replace(/[！-～]/g, tmpStr => {
        // 文字コードをシフト
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xfee0)
      })
      // 文字コードシフトで対応できない文字の変換
      return halfVal
        .replace(/”/g, '\'')
        .replace(/’/g, '\'')
        .replace(/‘/g, '`')
        .replace(/￥/g, '\\')
        .replace(/　/g, ' ') // eslint-disable-line no-irregular-whitespace
        .replace(/〜/g, '~')
    },
  },
}
